import script from "./invoice-enterprise-dialog-client.vue?vue&type=script&lang=tsx&name=invoice-enterprise-dialog-client&setup=true"
export * from "./invoice-enterprise-dialog-client.vue?vue&type=script&lang=tsx&name=invoice-enterprise-dialog-client&setup=true"

const __exports__ = script;

export default __exports__